import { ProductsGroup } from "features/ProductsGroup";
import { Products } from "features/Products";

import styles from "./styles.module.scss";

export const MainPage = (): JSX.Element => (
  <div className={styles.main}>
    <ProductsGroup />
    <Products />
  </div>
);
